import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse, errorRequestHandler } from 'utils';

/*
 * PROTESTS (25 Oct 2026). Kept out of the store: the mat reads them from its
 * workspace, the chief secretary's list reads them on its own — each screen
 * holds what it fetched, and every answer is the whole protest.
 */
const request = (api, body, params) => dispatch =>
    axios(apiRequestOptions(api, body, { params }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => {
            dispatch(errorRequestHandler(error));
            return Promise.reject(error);
        });

export const fetchProtests = competitionId =>
    request(apiPath.PROTEST.LIST, null, { competitionId });

/** The fights of one category a protest may name — latest round first. */
export const fetchProtestFights = (competitionId, categoryId) =>
    request(apiPath.PROTEST.FIGHTS, null, { competitionId, categoryId });

/** Stage one, the declaration: { categoryId, round, pair + side | participantId }; the time is the server's. */
export const registerProtest = (competitionId, body) =>
    request(apiPath.PROTEST.REGISTER, body, { competitionId });

/** { outcome, refusalReason, note, victoryClass } */
export const decideProtest = (protestId, body) =>
    request(apiPath.PROTEST.DECIDE, body, { id: protestId });

/** The people the form offers as the representative, for the athlete on whose behalf. */
export const fetchProtestRepresentatives = (competitionId, participantId) =>
    request(apiPath.PROTEST.REPRESENTATIVES, { participantId }, { competitionId });

/** Stage two, the form: { representativeName, representativeProfileId?, ruleClause, description }. */
export const fileProtest = (protestId, body) =>
    request(apiPath.PROTEST.FILE, body, { id: protestId });
